export default __webpack_public_path__ + "70eba3693ef6f4058864bc5ff626c414.svg";